import {
  DeleteOutlined,
  FormOutlined,
  PaperClipOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Upload,
  UploadFile,
  UploadProps,
  message,
} from "antd";
import ContractIcon from "assets/images/icons/contract.svg";
import AvatarTeacher from "assets/images/teacher/teacher.svg";
import axios from "axios";
import { CKEditor } from "ckeditor4-react";
import { HandlerInputError } from "common/enums";
import AppButton from "components/libs/button";
import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import ImageUploading from "react-images-uploading";
import { useSelector } from "react-redux";
import {
  useAddPostsMutation,
  useGetPostsCountsQuery,
  useGetPostsQuery
} from "store/services/teacher/activities.services";
import DocumentIcon from "../../../../../../../assets/images/app/file_icon.svg";
import PhotoIcon from "../../../../../../../assets/images/app/photo_icon.svg";
import TrashIcon from "../../../../../../../assets/images/app/trash_icon.svg";
import VideoIcon from "../../../../../../../assets/images/app/video_icon.svg";

import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import s from "./style.module.css";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const postFormData = async (formData: FormData) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${API_RESSOURCES}/posts`, formData, config);
};

const updatePostFormData = async (formData: FormData, postId: string) => {
  console.log(formData);
  return axios.patch(`${API_RESSOURCES}/posts/${postId}`, formData);
};

interface MainContentTopProps {
  onAddPostTop: () => void;
  handleAddDocsTop: (param: any) => void;
  isEditingPost: boolean;
  articleEditing: any;
  setIsEditingPost: React.Dispatch<any>;
}

// Define the shape of the uploaded file
interface UploadedFile extends UploadFile {
  fileName?: string;
}

const MainContentTop: React.FC<MainContentTopProps> = ({ onAddPostTop, handleAddDocsTop, isEditingPost, articleEditing, setIsEditingPost }) => {

  const imageUploadRef = useRef<HTMLButtonElement>(null);
  const videoUploadRef = useRef<HTMLDivElement>(null);
  const fileUploadRef = useRef<HTMLDivElement>(null);

  const [addPosts, { data, isLoading, isError, isSuccess }] =
    useAddPostsMutation();
  const [open, setOpen] = useState<boolean>(false);
  const [isArticle, setIsArticle] = useState<boolean>(false);
  const [content, setContent] = useState<string>("");
  const [images, setImages] = React.useState<any[]>([]);
  const [documents, setDocuments] = React.useState<any[]>([]);
  const [videos, setVideos] = React.useState<any[]>([]);
  const { user } = useSelector((state) => state.auth);
  const [loader, setLoader] = useState<boolean>(false);
  const { refetch } = useGetPostsQuery(user?._id);
  const [form] = Form.useForm();
  const maxNumber = 3;
  const { refetch: refetchPostCounts } = useGetPostsCountsQuery(user?._id);

  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [customFileNames, setCustomFileNames] = useState<string[]>([]);

  const [type, setType] = useState<string>("");

  const showUserModal = () => {
    setOpen(true);
  };

  const addPost = () => {
    setIsArticle(true);
    showUserModal();
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const iconData = [
    {
      icon: (
        <motion.img
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          src={PhotoIcon}
          width={isMobile ? 15 : 20}
          alt={"Image"}
          style={{ position: "relative", top: "0px" }}
        />
      ),
      width: isMobile ? 15 : 20,
      text: "Image",
      onClick: () => {
        setType("Image");
        imageUploadRef.current?.click();
      },
    },
    {
      icon: (
        <motion.img
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          src={VideoIcon}
          width={isMobile ? 15 : 20}
          alt={"Vidéo"}
          style={{ position: "relative", top: "0px" }}
        />
      ),
      width: isMobile ? 15 : 20,
      text: "Vidéo",
      onClick: () => {
        setType("Vidéo");
        setOpen(true);
        setTimeout(() => {
          videoUploadRef.current?.click();
        }, 500);
      },
    },
    {
      icon: (
        <motion.img
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          src={DocumentIcon}
          width={isMobile ? 15 : 20}
          alt={"Document"}
          style={{ position: "relative", top: "0px" }}
        />
      ),
      width: isMobile ? 15 : 20,
      text: "Document",
      onClick: () => {
        setType("Document");
        setOpen(true);
        setTimeout(() => {
          fileUploadRef.current?.click();
        }, 500);
      },
    },
    {
      icon: (
        <motion.img
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          src={ContractIcon}
          width={isMobile ? 15 : 20}
          alt={"Rédiger un article"}
          style={{ position: "relative", top: "0px" }}
        />
      ),
      width: isMobile ? 15 : 20,
      text: "Article",
      onClick: () => {
        setType("Article");
        setIsArticle(true);
        showUserModal();
      },
    },
  ];

  const onChange = (imageList: any, addUpdateIndex: any) => {
    if (isEditingPost) {
      if (images.length >= maxNumber) {
        message.warning(`Tu peux ajouter au maximum ${maxNumber} images. Les images supplémentaires ont été ignorées.`);
      } else {
        const newMaxNumber = maxNumber - images.length;
        const limitedImages = imageList.slice(0, newMaxNumber);
        // Add them to the existing ones
        const updatedImages = [...images, ...limitedImages];
        setImages(updatedImages);
      }
    }
    else {
      if (images.length === 0) {
        if (imageList.length > maxNumber) {
          // Keep only the first 3 images
          const limitedImages = imageList.slice(0, maxNumber);

          setImages(limitedImages);
          setOpen(true);

          message.warning(`Tu peux ajouter au maximum ${maxNumber} images. Les images supplémentaires ont été ignorées.`);
        } else {
          setImages(imageList);
          setOpen(true);
        }
      }
      else {
        if (images.length >= maxNumber) {
          message.warning(`Tu peux ajouter au maximum ${maxNumber} images. Les images supplémentaires ont été ignorées.`);
        } else {
          const newMaxNumber = maxNumber - images.length;
          const limitedImages = imageList.slice(0, newMaxNumber);
          // Add them to the existing ones
          const updatedImages = [...images, ...limitedImages];
          setImages(updatedImages);
        }
      }
    }
  };

  const onFinish = async (values: any) => {
    if (isEditingPost) {
      try {
        setLoader(true);

        const formData = new FormData();

        formData.append("content", values?.content);
        formData.append("profId", user?._id);

        // Handle images from ImageUploading
        if (images?.length > 0) {
          images.forEach((img: any) => {
            if (img?.file) {
              formData.append("files", img.file);
            }
          });
        }

        // Handle files from Ant Design Upload component
        if (values?.links?.fileList?.length > 0) {
          values.links.fileList.forEach((fileItem: any) => {
            if (fileItem?.originFileObj) {
              formData.append("files", fileItem.originFileObj);
            }
          });
        }

        if (customFileNames.length > 0) {
          formData.append("fileNames", JSON.stringify(customFileNames));
        }

        videos.forEach((video: any) => {
          formData.append("files", video?.originFileObj);
        });

        const response = await updatePostFormData(formData, articleEditing?._id);

        setContent("");
        setImages([]);
        setIsArticle(false);
        setUploadedFiles([]);
        setCustomFileNames([]);
        setVideos([])
        message.info("Publication modifiée avec succès !");
        form.resetFields();
        refetch();
        refetchPostCounts();
        onAddPostTop();
        handleAddDocsTop(documents.length + videos.length)
        setTimeout(() => {
          setOpen(false);
        }, 500);

        return response.data;


      } catch (error) {
        console.log(error);
        throw new Error(
          "Une erreur s'est produite lors du téléchargement du fichier."
        );
      } finally {
        setLoader(false);
      }
    }
    else {
      try {
        setLoader(true);

        const formData = new FormData();

        formData.append("content", values?.content);
        formData.append("profId", user?._id);

        // Handle images from ImageUploading
        if (images?.length > 0) {
          images.forEach((img: any) => {
            if (img?.file) {
              formData.append("links", img.file);
            }
          });
        }

        // Handle files from Ant Design Upload component
        if (values?.links?.fileList?.length > 0) {
          values.links.fileList.forEach((fileItem: any) => {
            if (fileItem?.originFileObj) {
              formData.append("links", fileItem.originFileObj);
            }
          });
        }

        if (customFileNames.length > 0) {
          formData.append("fileNames", JSON.stringify(customFileNames));
        }

        videos.forEach((video: any) => {
          formData.append("links", video?.originFileObj);
        });

        const response = await postFormData(formData);

        setContent("");
        setImages([]);
        setIsArticle(false);
        setUploadedFiles([]);
        setCustomFileNames([]);
        setVideos([])
        message.info("Publication réussie !");
        form.resetFields();
        refetch();
        refetchPostCounts();
        onAddPostTop();
        handleAddDocsTop(documents.length + videos.length)
        setTimeout(() => {
          setOpen(false);
        }, 500);

        return response.data;


      } catch (error) {
        console.log(error);
        throw new Error(
          "Une erreur s'est produite lors du téléchargement du fichier."
        );
      } finally {
        setLoader(false);
      }
    }
  };

  // Upload Documents props
  const props: UploadProps = {
    name: "file",
    maxCount: 5,
    fileList: uploadedFiles,

    onChange(info) {
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        info.file.status = "done";
      }

      // Handle fileList state update
      const updatedFiles = info.fileList.map((item) => {
        const { error, response, ...rest } = item;
        return rest as UploadedFile;
      });

      // Set uploaded files into state
      setUploadedFiles(updatedFiles);
    },
  };

  // Handler for custom file name input change
  const handleFileNameChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = [...uploadedFiles];
    newFiles[index].fileName = event.target.value;
    setUploadedFiles(newFiles);
    handleFileName(index);
  };

  // Function to handle blur event to update custom file names array
  const handleFileName = (index: number) => {
    const currentFileName = uploadedFiles[index].fileName || "";
    const newCustomNames = [...customFileNames];

    // Update the custom name at the specific index
    if (newCustomNames[index] !== currentFileName) {
      newCustomNames[index] = currentFileName;
      setCustomFileNames(newCustomNames);
    }
  };

  // Function to delete a file from uploadedFiles
  const handleDeleteFile = (index: number) => {
    const newFiles = uploadedFiles.filter((_, i) => i !== index);
    const newCustomNames = customFileNames.filter((_, i) => i !== index);
    setUploadedFiles(newFiles);
    setCustomFileNames(newCustomNames);
  };

  // Upload Video Props
  const uploadPropsVideo: UploadProps = {
    name: "video",
    multiple: false, // explicitly allow only one
    beforeUpload: () => false,
    onChange(info) {
      if (info.file.status !== "uploading") { }

      if (info.file.status === "done") {
        message.success(`${info.file.name} vidéo envoyée avec succès`);
      } else if (info.file.status === "error") {
        info.file.status = "done";
      }

      // Filter out unneeded props
      const filteredJson = info.fileList.map((item) => {
        const { error, response, ...rest } = item;
        return rest;
      });

      // Only keep the most recent upload
      const latestVideo = filteredJson.slice(-1);

      setVideos(latestVideo);
      setOpen(true);
    },
  };


  useEffect(() => {
    if (isEditingPost) {
      if (articleEditing) {
        form.setFieldsValue({
          "content": articleEditing?.content,
        });
        if (articleEditing?.links.length !== 0) {
          articleEditing?.links.forEach(async (data: any) => {
            if (data?.type.split("/")[0] === "image") {
              const secureUrl = data.url.replace(/^http:\/\//i, "https://");

              const response = await fetch(secureUrl);
              const blob = await response.blob();

              const imageData = {
                data_url: secureUrl,
                file: new File([blob], data.fileName || "image.jpg", {
                  type: data.type,
                  lastModified: Date.now(),
                }),
              };
              setImages((prevImages) => [...prevImages, imageData]);
              setIsArticle(false);
              setOpen(true);
            }
            else if (data?.type.split("/")[0] === "video") {
              const secureUrl = data.url.replace(/^http:\/\//i, "https://");

              try {
                const response = await fetch(secureUrl);
                const blob = await response.blob();
                const fileName = secureUrl.split("/").pop() || "video.mp4";

                // Create a mock upload file object like Ant Design UploadProps provides
                const videoFile = {
                  uid: Date.now().toString(),
                  name: fileName,
                  status: "done",
                  type: blob.type || "video/mp4",
                  url: secureUrl,
                  originFileObj: blob,
                };

                setVideos((prev: any[]) => [...prev, videoFile]);
                setOpen(true);
              } catch (error) {
                console.error("Error fetching video:", error);
              }
            }
            else if (data?.type.split("/")[0] === "application") {
              const secureUrl = data.url.replace(/^http:\/\//i, "https://");
              const response = await fetch(secureUrl);

              try {
                const response = await fetch(secureUrl);
                const blob = await response.blob();

                // Convert the fetched file into a File-like object
                const file = new File([blob], data?.fileName + ".pdf" || "document.pdf", { type: blob.type });

                // Create an Ant Design-compatible file entry
                const newFile = {
                  uid: Date.now().toString(), // unique id
                  name: file.name,
                  status: "done",
                  originFileObj: file,
                  url: secureUrl, // allows preview / download in Upload component
                  type: blob.type,
                  fileName: data?.fileName,
                };

                // Update your Upload component state
                setUploadedFiles((prev: any[]) => [...prev, newFile]);
                setCustomFileNames((prevNames) => [...prevNames, newFile.fileName]);

                setIsArticle(false);
                setOpen(true);
              } catch (err) {
                console.error("Error fetching file:", err);
              }
            }
          });
        }
        else {
          setIsArticle(false);
          setOpen(true);
        }
      }
    }
  }, [isEditingPost, articleEditing]);

  useEffect(() => {
    if (isEditingPost && uploadedFiles) {
      const nameValues = uploadedFiles.reduce((acc, file, index) => {
        acc[`name${index}`] = file.fileName || "";
        return acc;
      }, {} as Record<string, string>);

      form.setFieldsValue(nameValues);
    }
  }, [uploadedFiles, isEditingPost]);

  return (
    <div className={s.commentBox}>
      <div className={s.post}>
        <div className={s.input} onClick={showUserModal}>
          <Avatar size={30} src={user?.profile || AvatarTeacher} />
          <Form.Item name="content" rules={[{ required: false }]} noStyle>
            <Input
              style={{ cursor: "pointer" }}
              className={s.field}
              bordered={false}
              placeholder={
                content ? "Continuer le post..." : "Commencer un post ..."
              }
              onClick={showUserModal}
              onChange={showUserModal}
            />
          </Form.Item>
        </div>

        <div className={s.postContainer}>
          {iconData.map((item, index) => (
            <Col key={index}>
              <Space onClick={item?.onClick} className={s.postButton}>
                {item.icon}
                <span>{item.text}</span>
              </Space>
            </Col>
          ))}
        </div>

        <Modal
          title={false}
          visible={open}
          okText="Publier"
          cancelText="Fermer"
          onCancel={() => { setOpen(false); setIsArticle(false); setContent(''); setImages([]); setDocuments([]); setVideos([]); form.resetFields(); setIsEditingPost(false); setUploadedFiles([]); setCustomFileNames([]) }}
          width={isArticle ? 1000 : 700}
          centered
          footer={false}
        >
          <Form
            form={form}
            layout="vertical"
            name="userForm"
            onFinish={onFinish}
          >

            {images.length !== 0 && <div className={s.imageBox}>
              <div className={s.imagePreviewBox}>
                {images.map((image: any, index: number) => {
                  return (
                    <>
                      <div className={s.imagePreview} key={index}>
                        <Popconfirm
                          placement="bottom"
                          title={
                            "Veux-tu supprimer cette image du post ?"
                          }
                          onConfirm={() => {
                            setImages((prevImages: any[]) =>
                              prevImages.filter((_, i) => i !== index)
                            );
                          }}
                          okText={"Oui"}
                          cancelText="Non"
                        >
                          <div className={s.deleteButton}>
                            <img src={TrashIcon} height={20} style={{ filter: "brightness(0) invert(1)" }} />
                          </div>
                        </Popconfirm>
                        <img src={image?.data_url} alt="" />
                      </div>
                    </>);
                })}
              </div>
              <Button icon={<UploadOutlined />} onClick={() => imageUploadRef.current?.click()}>
                Upload d'image
              </Button>
            </div>}

            {videos.length !== 0 ? (
              <div className={s.videoPreview}>
                <Popconfirm
                  placement="bottom"
                  title={
                    "Veux-tu supprimer cette vidéo du post ?"
                  }
                  onConfirm={() => {
                    setVideos([]);
                  }}
                  okText={"Oui"}
                  cancelText="Non"
                >
                  <div className={s.deleteVideoButton}>
                    <img src={TrashIcon} height={20} style={{ filter: "brightness(0) invert(1)" }} />
                  </div>
                </Popconfirm>
                <video key={videos[0].uid} controls>
                  <source src={URL.createObjectURL(videos[0].originFileObj)} />
                </video>
                <Upload
                  {...uploadPropsVideo}
                  accept=".mov,.mp4"
                  maxCount={1}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />} style={{ marginTop: "10px" }}>
                    Upload de vidéo
                  </Button>
                </Upload>
              </div>
            ) : (
              <Upload
                {...uploadPropsVideo}
                accept=".mov,.mp4"
                maxCount={1}
              >
                <div ref={videoUploadRef} />
              </Upload>
            )}

            <div className={s.inputTextarea} style={{ marginTop: "2em" }}>
              {isArticle ? (
                <Form.Item
                  name={"content"}
                  valuePropName="data"
                  getValueFromEvent={(event) => {
                    const data = event?.editor?.getData();
                    setContent(data);
                    return data;
                  }}
                  rules={[
                    {
                      required: true,
                      message: HandlerInputError.content,
                    },
                  ]}
                >
                  <CKEditor
                    initData={content}
                    config={{
                      language: 'fr',
                    }}
                    style={{
                      border: "none",
                    }}
                  />
                </Form.Item>
              ) : (
                <Form.Item
                  name={"content"}
                  rules={[
                    {
                      required: true,
                      message: HandlerInputError.content,
                    },
                  ]}
                  valuePropName="value"
                  getValueFromEvent={(content) => content}
                >
                  {/* <Input.TextArea
                    rows={10}
                    bordered={false}
                    onChange={(v) => setContent(v.target.value)}
                  /> */}
                  <ReactQuill
                    theme="snow"
                    modules={{ toolbar: false }}
                    style={{ height: "200px" }}
                    value={content}
                    onChange={setContent}
                  />
                </Form.Item>
              )}
            </div>

            <Row gutter={12}>
              <Col>
                {isArticle && (
                  <Button
                    onClick={() => {
                      setOpen(false);
                      setIsArticle(false);
                      setContent("");
                      form.resetFields();
                    }}
                  >
                    Annuler l'article
                  </Button>
                )}
              </Col>

              <div className={s.field}>
                {type === "Document" && <Form.Item
                  style={{ margin: 0, padding: 0 }}
                  name="links"
                  rules={[{ required: false, message: HandlerInputError.default }]}
                >
                  <Upload {...props} accept="application/pdf" maxCount={5} showUploadList={false}>
                    <Button ref={fileUploadRef} icon={<UploadOutlined />} type="text">
                      Upload de document
                    </Button>
                  </Upload>
                </Form.Item>}

                {/* Render uploaded files and their file name inputs */}
                {uploadedFiles.map((file: any, index) => (
                  <div key={file.uid} style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "10px", marginLeft: "20px", marginBottom: "10px" }}>
                    <PaperClipOutlined style={{ marginRight: "10px", fontSize: "16px" }} />
                    <div style={{ marginRight: "10px", width: "200px" }}>{file?.name}</div>
                    <div key={index} style={{ width: "300px" }}>
                      <Form.Item
                        style={{ margin: 0, padding: 0 }}
                        name={`name${index}`}
                        rules={[
                          {
                            required: true,
                            message: HandlerInputError.default,
                          },
                          { max: 50, message: "Max 50 char" },
                        ]}
                      >
                        <Input
                          className={s.field}
                          placeholder="Titre du document"
                          value={file?.fileName || ""}
                          onChange={(event) => handleFileNameChange(index, event)}
                          style={{ width: "300px" }}
                        />
                      </Form.Item>
                    </div>
                    <DeleteOutlined
                      style={{ cursor: 'pointer', color: 'red', marginLeft: "20px" }}
                      onClick={() => handleDeleteFile(index)}
                    />
                  </div>
                ))}
              </div>
            </Row>

            <Row justify="center" style={{ marginTop: "2em" }}>
              <Form.Item>
                <AppButton htmlTypeSubmit={true} loading={loader}>
                  Publier
                </AppButton>
              </Form.Item>
            </Row>
          </Form>
        </Modal>
      </div>

      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        /* maxNumber={maxNumber} */
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <React.Fragment>
            <button
              ref={imageUploadRef}
              type="button"
              className={s.btn__Upload}
              style={
                isDragging
                  ? { color: "red" }
                  : { position: "absolute", left: "-100%" }
              }
              onClick={() => {
                imageList[0]?.data_url ? onImageUpdate(0) : onImageUpload();
              }}
              {...dragProps}
            >
              <FormOutlined
                style={{
                  fontWeight: "600 !important",
                  color: "var(--first-color)",
                  fontSize: "15px",
                }}
              />
            </button>
          </React.Fragment>
        )}
      </ImageUploading>
    </div>
  );
};

export default MainContentTop;
